import React, { useContext } from 'react'
import classes from './TechnicalExpertiseMainBlock.module.css'
import { ThemeContext } from '../../App'



interface TechnicalExpertiseMainBlockProps {
  technicalExpertiseMainBlock: {
    title: string,
    imageSource: string
  }
}

const TechnicalExpertisePreviewBlock: React.FC<TechnicalExpertiseMainBlockProps> = ({
  technicalExpertiseMainBlock: { title, imageSource }, }) => {

  const { theme } = useContext(ThemeContext)

  return (
    <div className={classes.container}>
      <div id={classes[theme]} className={classes.mainBlock}>
        <h3 className={classes.weHelpH + ' text-center text-smTitlesForH md:text-mdBtwPages lg:text-lgBtwPages w-vw90 mx-auto'}>{title}</h3>

        <div className='p-10vwrl  mx-auto flex flex-col lg:flex-row justify-between items-center'>

          <div className='w-12/12 mb-bottom-vh10 flex justify-center'>
            <img src={imageSource} className='w-4/5 md:w-full lg:w-4/5' />
          </div>


          <div className='w-12/12 lg:w-6/12 lg:order-first'>
            <div className='w-4/5 mb-bottom-vh5 md:w-full lg:w-4/5'>
              <p className='text-cyan-400 text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lgSepBtnTxt md:mb-2 lg:mb-0'>1. Get started</p>
              <p className='text-smAdd2Txt md:text-mdAddTxt lg:text-lg2AddTxt'>Begin your journey by establishing the essentials. Lay down foundational practices and principles to kickstart your data initiatives.</p>
            </div>
            <div className='w-4/5 mb-bottom-vh5 md:w-full lg:w-4/5'>
              <p className='text-yellow-400 text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lgSepBtnTxt md:mb-2 lg:mb-0'>2. Make the Change Feasible</p>
              <p className='text-smAdd2Txt md:text-mdAddTxt lg:text-lg2AddTxt'>Plan and strategize to make changes practical and achievable. Ensure your proposed changes align with your goals and can be seamlessly integrated</p>
            </div>
            <div className='w-4/5 md:w-full lg:w-4/5'>
              <p className='text-red-400 text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lgSepBtnTxt md:mb-2 lg:mb-0'>3. Be the Change</p>
              <p className='text-smAdd2Txt md:text-mdAddTxt lg:text-lg2AddTxt'>Embrace transformation by actively implementing significant changes. Redesign processes and adopt innovative approaches to become a driving force in the data landscape</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default TechnicalExpertisePreviewBlock
